<template>
  <div class="x3page">
    <div class="x3head">
      <van-cell class="vc" title="类型"  title-class="tctil">
        <template>
          <div class="type-btns" :class="{'only':!openWalleted}">
            <div class="btn" :class="{ active: type == 1 }" @click="toggle(1)" v-if="app.permission.op('stored_card_charge')">储值卡充值</div>
            <div class="btn" :class="{ active: type == 2 }" @click="toggle(2)" v-if="openWalleted">电子钱包预存</div>
          </div>
        </template>
      </van-cell>
    </div>
    <div class="x3main">
      <!-- 储值卡充值 -->
      <prestore-card v-if="type == 1 && app.permission.op('stored_card_charge')" :phone="phone"/>
      <!-- 电子钱包预存 -->
      <prestore-wallet v-if="type == 2 && openWalleted"/>
    </div>
    <image-list ref="image"></image-list>
  </div>
</template>

<script>
import prestoreCard from './prestore-child/prestore-card.vue';
import prestoreWallet from './prestore-child/prestore-wallet.vue';
import imageList from '@x3/vue/comp/image-list.vue';
export default {
  components: {
    prestoreCard,
    prestoreWallet,
    imageList,
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
    openWalleted() {
      return (
        app.tool
          .safeReadObjProp(this.userInfo, 'companyInfoVo.companyAppOpenList')
          .indexOf('WALLET') > -1
      );
    },
  },
  provide(){
    return {
      openImage: (list)=>{
        return this.$refs.image.open(list);
      }
    }
  },
  data() {
    return {
      pageTitle: '预存充值',
      type: '',
      phone: this.$route.query.phone,
      cardid: this.$route.query.cardid,
    };
  },
  methods: {
    toggle(type) {
      if (this.type != type) {
        this.type = type;
      }
    },
  },
  created() {
    this.type = this.$route.query.type ? this.$route.query.type : (app.permission.op('stored_card_charge') ? 1 : this.openWalleted ? 2 : '');
  }
};
</script>

<style lang="scss" scoped>
.x3page {
  .x3head {
    margin-bottom: calc(var(--gap) * 12);
    .vc {
      padding: calc(var(--gap) * 10) calc(var(--gap) * 16);
      .van-cell__title {
        flex: none;
        width: calc(var(--gap) * 100);
      }
      .van-cell__value {
        display: flex;
        justify-content: flex-end;
        .type-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          width: calc(var(--w) * 203);
          height: calc(var(--w) * 32);
          font-size: var(--fs-md);
          font-weight: 400;
          color: var(--g8);
          background: var(--g1);
          border-radius: var(--radius-base);
          border: 1px solid var(--g3);
          overflow: hidden;
          &.only {
            width: calc(var(--gap) * 102);
          }
          .btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: var(--radius-base);
            &.active {
              color: var(--white);
              background: var(--c1);
            }
          }
        }
      }
    }
  }
}
</style>
